export var PLACE_TYPE;
(function (PLACE_TYPE) {
  PLACE_TYPE["NATION"] = "N";
  PLACE_TYPE["REGION"] = "R";
  PLACE_TYPE["PROVINCE"] = "P";
  PLACE_TYPE["CITY"] = "C";
  PLACE_TYPE["ZONE"] = "Z";
  PLACE_TYPE["LOCALITY"] = "L";
  PLACE_TYPE["AREA_OF_INTEREST"] = "I";
  PLACE_TYPE["AREA"] = "A";
  PLACE_TYPE["DISTRICT"] = "D";
})(PLACE_TYPE || (PLACE_TYPE = {}));